export class globalSearch_actions {
    static setDashboardSearchItems(items) {
        return { type: 'SET_DASHBOARD_SEARCH_ITEMS', payload: items };
    }
    static setApplicationsSearchItems(items) {
        return { type: 'SET_APPLICATIONS_SEARCH_ITEMS', payload: items };
    }
    static setSearchText(text) {
        return { type: 'SET_GLOBAL_SEARCH_TEXT', payload: text };
    }
    static setDisplayText(text) {
        return { type: 'SET_GLOBAL_SEARCH_DISPLAY_TEXT', payload: text };
    }
    static setSearchOpen(open) {
        return { type: 'SET_GLOBAL_SEARCH_OPEN', payload: open };
    }
    static setActiveTab(tab) {
        return { type: 'SET_GLOBAL_SEARCH_ACTIVE_TAB', payload: tab };
    }
    static clearSearch() {
        return { type: 'CLEAR_GLOBAL_SEARCH' };
    }
    static setPendingContractIdSearch(contractId) {
        return { type: 'SET_PENDING_CONTRACT_ID_SEARCH', payload: contractId };
    }
    static clearPendingContractIdSearch() {
        return { type: 'CLEAR_PENDING_CONTRACT_ID_SEARCH' };
    }
}
